let activeScrollAnimationFrame = null;

const easeInOutCubic = (progress) => (
  progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - (Math.pow(-2 * progress + 2, 3) / 2)
);

export const scrollToSectionById = (
  id,
  {
    offset = 96,
    duration = 1100,
    updateHash = true,
  } = {},
) => {
  if (typeof window === "undefined" || typeof document === "undefined") return false;

  const element = document.getElementById(id);

  if (!element) return false;

  const startY = window.scrollY;
  const targetY = Math.max(
    element.getBoundingClientRect().top + window.scrollY - offset,
    0,
  );
  const distance = targetY - startY;

  if (updateHash) {
    const nextUrl = `${window.location.pathname}${window.location.search}#${id}`;
    window.history.replaceState(null, "", nextUrl);
  }

  if (Math.abs(distance) < 2) {
    window.scrollTo({ top: targetY });
    return true;
  }

  if (activeScrollAnimationFrame) {
    window.cancelAnimationFrame(activeScrollAnimationFrame);
  }

  const startTime = window.performance.now();

  const animate = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutCubic(progress);

    window.scrollTo({
      top: startY + (distance * easedProgress),
    });

    if (progress < 1) {
      activeScrollAnimationFrame = window.requestAnimationFrame(animate);
      return;
    }

    activeScrollAnimationFrame = null;
  };

  activeScrollAnimationFrame = window.requestAnimationFrame(animate);
  return true;
};
